const DashboardForDepartmentActionTypes = {
	DASHBOARDFORDEPARTMENT_START: 'dashboardfordepartment_start',
	DASHBOARDFORDEPARTMENT_SUCCESS: 'dashboardfordepartment_success',
	DASHBOARDFORDEPARTMENT_FAILURE: 'dashboardfordepartment_failure',
	DASHBOARDFORDEPARTMENT_RESPONSE_CHANGED: 'dashboardfordepartment_response_changed',
	DASHBOARDFORDEPARTMENT_RESPONSE_REST_START: 'dashboardfordepartment_response_rest_start',
	DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_START: 'dashboardfordepartment_attendance_by_sectionwise_start',
	DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_SUCCESS: 'dashboardfordepartment_attendance_by_sectionwise_success',
	DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_FAILURE: 'dashboardfordepartment_attendance_by_sectionwise_failure',
	DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_RESPONSE_CHANGED: 'dashboardfordepartment_attendance_by_sectionwise_response_changed',
	DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_RESPONSE_REST_START: 'dashboardfordepartment_attendance_by_sectionwise_response_rest_start',
	DASHBOARDFORHOATTENDANCE_BY_SECTIONWISE_START: 'dashboardforhoattendance_by_sectionwise_start',
} as const;

export type DashboardForDepartmentActionType = typeof DashboardForDepartmentActionTypes[keyof typeof DashboardForDepartmentActionTypes];

export default DashboardForDepartmentActionTypes;